import axios from 'axios';

const getUser = () => axios.get('/user');
const aceitarTermo = () => axios.put('/user/aceitar-termo', {});

export default {
  getUser,
  aceitarTermo,
};
